import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/test',
      name: 'test',
      component: () => import('./views/test'),
      meta: { title: '云柑社区', requireAuth: false, cn: 'test'}
    },
    // {
    //   path: '/antpay',
    //   name: 'antpay',
    //   component: () => import('./components/antpay/antpay'),
    //   meta: {cn: '支付密码'}
    // },
    {
      path: '/loginBefore',
      name: 'loginBefore',
      props: true,
      component: () => import('./views/loginBefore'),
      meta: { title: '云柑社区', requireAuth: false, cn: '微信登录前处理数据的页面'}
    },
    {
      path: '/login',
      name: 'login',
      props: true,
      component: () => import('./views/login'),
      meta: { title: '云柑社区', requireAuth: false, cn: '微信登录页'}
    },
    {
      path: '/loginPhone',
      name: 'loginPhone',
      props: true,
      component: () => import('./views/loginPhone'),
      meta: { title: '云柑社区', requireAuth: false, cn: '手机登录页'}
    },

    {
      path: '/',
      redirect: '/mall',
      component: () => import('./components/base'),
      children: [
        {
          path: '/mallold',
          name: 'mallold',
          props: true,
          component: () => import('./views/Mall/indexold'),
          meta: {title: '蚂蚁商城-旧', requireAuth: false, cn: '商城',active: 0}
        },
        {
          path: '/mall',
          name: 'mall',
          props: true,
          component: () => import('./views/Mall/index'),
          meta: {title: '云柑商城', requireAuth: true, cn: '商城',active: 0}
        },
        {
          path: '/article',
          name: 'article',
          props: true,
          component: () => import('./views/Article'),
          meta: {title: '云柑号', requireAuth: true, cn: '云柑号',active: 1}
        },{
          path: '/my',
          name: 'my',
          props: true,
          component: () => import('./views/My'),
          meta: {title: '我的', requireAuth: true, cn: '我的',active: 2}
        },
      ]

    },


    // {
    //   path: '/audioPlayer',
    //   name: 'audioPlayer',
    //   props: true,
    //   component: () => import('./components/audioPlayer'),
    //   meta: { requireAuth: true, cn: '音频'}
    // },
    {
      path: '/404',
      name: '404',
      props: true,
      component: () => import('./views/404'),
      meta: { title: '云柑社区', requireAuth: false, cn: '404'}
    },
    {
      path: '/tipVideo',
      name: 'tipVideo',
      props: true,
      component: () => import('./views/tipVideo'),
      meta: { title: '云柑社区', requireAuth: true, cn: '视频'}
    },
    {
      path: '/picLive',
      name: 'picLive',
      props: true,
      component: () => import('./views/Live/PicLive'),
      meta: { title: '云柑社区', requireAuth: true, cn: '图文直播'}
    },
    {
      path: '/vedioLive',
      name: 'vedioLive',
      props: true,
      component: () => import('./views/Live/VedioLive'),
      meta: { title: '云柑社区', requireAuth: true, cn: '语音/视频 直播'}
    },
    // {
    //   path: '/chatRoom',
    //   name: 'chatRoom',
    //   props: true,
    //   component: () => import('./views/Live/ChatRoom'),
    //   meta: { title: '云柑社区', requireAuth: true, cn: '不直接访问-聊天室'}
    // },
    {
      path: '/vedioLiveReLook',
      name: 'vedioLiveReLook',
      props: true,
      component: () => import('./views/liveReLook/vedio'),
      meta: { title: '云柑社区', requireAuth: true, cn: '直播视频回看--视频'}
    },
    {
      path: '/audioLiveReLook',
      name: 'audioLiveReLook',
      props: true,
      component: () => import('./views/liveReLook/audio'),
      meta: { title: '云柑社区', requireAuth: true, cn: '直播视频回看--音频'}
    },
    {
      path: '/orgLive',
      name: 'orgLive',
      props: true,
      component: () => import('./views/orgLive/VedioLive'),
      meta: { title: '云柑社区', requireAuth: true, cn: '语音/视频 直播'}
    },
    {
      path: '/shortVideo',
      name: 'shortVideo',
      props: true,
      component: () => import('./views/Live/shortVideo'),
      meta: { title: '云柑社区', requireAuth: true, cn: '云柑号短视频'}
    },


    {
      path: '/my/information',
      name: 'information',
      props: true,
      component: () => import('./views/My/Information'),
      meta: { title: '云柑社区', requireAuth: true, cn: '个人信息'}
    },
    {
      path: '/my/QRCode/:inviteCode',
      name: 'QRCode',
      props: true,
      component: () => import('./views/My/QRCode'),
      meta: { title: '云柑社区', requireAuth: true, cn: '个人信息-二维码'}
    },

    {
      path: '/my/information/informationMore',
      name: 'informationMore',
      component: () => import('./views/My/Information/InformationMore'),
      meta: { title: '云柑社区', requireAuth: true, cn: '个人信息-更多'}
    },
    {
      path: '/my/information/addressList',
      name: 'addressList',
      props: true,
      component: () => import('./views/My/Information/addressList'),
      meta: { title: '收货地址',  requireAuth: true, cn: '收货地址'}
    },
    {
      path: '/my/information/editAddress',
      name: 'editAddress',
      props: true,
      component: () => import('./views/My/Information/EditAddress'),
      meta: { title: '云柑社区', requireAuth: true, cn: '收货地址'}
    },


    {
      path: '/my/wallet',
      name: 'wallet',
      props: true,
      component: () => import('./views/My/Wallet'),
      meta: { title: '云柑钱包', requireAuth: true, cn: '钱包'}
    },
    {
      path: '/my/wallet/setting',
      name: 'walletSetting',
      props: true,
      component: () => import('./views/My/Wallet/Setting'),
      meta: { title: '设置密码', requireAuth: true, cn: '钱包-设置'}
    },
    // {
    //   path: '/my/wallet/passSet',
    //   name: 'passSet',
    //   props: true,
    //   component: () => import('./views/My/Wallet/PassSet'),
    //   meta: {title: '设置支付密码', requireAuth: true, cn: '钱包-设置密码'}
    // },
    {
      path: '/my/wallet/passChange',
      name: 'passChange',
      props: true,
      component: () => import('./views/My/Wallet/PassChange'),
      meta: { title: '修改密码', requireAuth: true, cn: '钱包-更改密码'}
    },
    {
      path: '/my/wallet/passForget',
      name: 'passForget',
      props: true,
      component: () => import('./views/My/Wallet/PassForget'),
      meta: { title: '找回密码', requireAuth: true, cn: '钱包-忘记密码'}
    },
    {
      path: '/my/wallet/cash',
      name: 'cash',
      props: true,
      component: () => import('./views/My/Wallet/Cash'),
      meta: { title: '奖金余额', requireAuth: true, cn: '钱包-现金'}
    },
    // {
    //   path: '/my/wallet/CashIn',
    //   name: 'cashIn',
    //   props: true,
    //   component: () => import('./views/My/Wallet/CashIn'),
    //   meta: { title: '现金充值', requireAuth: true, cn: '钱包-现金-现金充值'}
    // },
    // {
    //   path: '/my/wallet/cashInHistory',
    //   name: 'cashInHistory',
    //   props: true,
    //   component: () => import('./views/My/Wallet/CashInHistory'),
    //   meta: { title: '余额充值记录', requireAuth: true, cn: '钱包-现金-充值记录'}
    // },
    {
      path: '/my/wallet/CashOut',
      name: 'cashOut',
      props: true,
      component: () => import('./views/My/Wallet/CashOut'),
      meta: { title: '余额提现', requireAuth: true, cn: '钱包-现金-提现'}
    },
    {
      path: '/my/wallet/CashOutConfirm',
      name: 'cashOutConfirm',
      props: true,
      component: () => import('./views/My/Wallet/CashOutConfirm'),
      meta: { title: '申请提现', requireAuth: true, cn: '钱包-现金-提现-申请提现'}
    },
    {
      path: '/my/wallet/cashOutHistory',
      name: 'cashOutHistory',
      props: true,
      component: () => import('./views/My/Wallet/CashOutHistory'),
      meta: { title: '提现记录', requireAuth: true, cn: '钱包-现金-提现记录'}
    },
    {
      path: '/my/wallet/cashHistory',
      name: 'cashHistory',
      props: true,
      component: () => import('./views/My/Wallet/CashHistory'),
      meta: { title: '余额记录', requireAuth: true, cn: '钱包-现金记录'}
    },
    // {
    //   path: '/my/wallet/cashTransfer',
    //   name: 'cashTransfer',
    //   props: true,
    //   component: () => import('./views/My/Wallet/CashTransfer'),
    //   meta: { title: '转账', requireAuth: true, cn: '钱包-现金转账'}
    // },
    {
      path: '/my/wallet/cashBankCard',
      name: 'cashBankCard',
      props: true,
      component: () => import('./views/My/Wallet/CashBankCard'),
      meta: { title: '选择银行卡', requireAuth: true, cn: '钱包-现金-余额提现-银行卡列表'}
    },
    {
      path: '/my/wallet/cashBankCardAdd',
      name: 'cashBankCardAdd',
      props: true,
      component: () => import('./views/My/Wallet/CashBankCardAdd'),
      meta: { title: '添加银行卡', requireAuth: true, cn: '钱包-现金-余额提现-银行卡列表-添加银行卡'}
    },

    {
      path: '/my/wallet/coin',
      name: 'coin',
      props: true,
      component: () => import('./views/My/Wallet/Coin'),
      meta: { title: '云柑金币', requireAuth: true, cn: '钱包-金币'}
    },
    // {
    //   path: '/my/wallet/coinIn',
    //   name: 'coinIn',
    //   props: true,
    //   component: () => import('./views/My/Wallet/CoinIn'),
    //   meta: { title: '金币充值', requireAuth: true, cn: '钱包-金币-金币充值'}
    // },
    // {
    //   path: '/my/wallet/coinInHistory',
    //   name: 'coinInHistory',
    //   props: true,
    //   component: () => import('./views/My/Wallet/CoinInHistory'),
    //   meta: { title: '金币充值记录', requireAuth: true, cn: '钱包-金币-充值记录'}
    // },
    {
      path: '/my/wallet/coinOut',
      name: 'coinOut',
      props: true,
      component: () => import('./views/My/Wallet/CoinOut'),
      meta: { title: '转移金币', requireAuth: true, cn: '钱包-金币-转移'}
    },
    {
      path: '/my/wallet/coinOutHistory',
      name: 'coinOutHistory',
      props: true,
      component: () => import('./views/My/Wallet/CoinOutHistory'),
      meta: { title: '转移记录', requireAuth: true, cn: '钱包-金币-转移记录'}
    },
    {
      path: '/my/wallet/coinHistory',
      name: 'coinHistory',
      props: true,
      component: () => import('./views/My/Wallet/CoinHistory'),
      meta: { title: '金币记录', requireAuth: true, cn: '钱包-金币记录'}
    },

    {
      path: '/my/wallet/liveCard',
      name: 'liveCard',
      props: true,
      component: () => import('./views/My/Wallet/LiveCard'),
      meta: { title: '直播充值管理', requireAuth: true, cn: '钱包-直播充值管理'}
    },
    {
      path: '/my/wallet/liveCardIn',
      name: 'liveCardIn',
      props: true,
      component: () => import('./views/My/Wallet/LiveCardIn'),
      meta: { title: '直播流量充值', requireAuth: true, cn: '钱包-直播充值管理-充值'}
    },
    {
      path: '/my/wallet/liveCardHistory',
      name: 'liveCardHistory',
      props: true,
      component: () => import('./views/My/Wallet/LiveCardHistory'),
      meta: { title: '余额记录', requireAuth: true, cn: '钱包-直播充值管理-充值记录'}
    },

    {
      path: '/my/follow',
      name: 'follow',
      props: true,
      component: () => import('./views/My/Follow/index'),
      meta: { title: '关注', requireAuth: true, cn: '关注'}
    },
    {
      path: '/my/shoppingCart',
      name: 'shoppingCart',
      props: true,
      component: () => import('./views/My/ShoppingCart/index'),
      meta: { title: '购物车', requireAuth: true, cn: '购物车'}
    },
    {
      path: '/my/collection',
      name: 'collection',
      props: true,
      component: () => import('./views/My/Collection/index'),
      meta: { title: '收藏', requireAuth: true, cn: '收藏'}
    },

    {
      path: '/my/invitation',
      name: 'invitation',
      props: true,
      component: () => import('./views/My/Invitation'),
      meta: { title: '云柑社区', requireAuth: true, cn: '邀请好友'}
    },
    /*{
      path: '/my/member',
      name: 'member',
      props: true,
      component: () => import('./views/My/Member'),
      meta: { title: '会员管理', requireAuth: true, cn: '会员管理'}
    },*/
    {
      path: '/my/member/membership-rules',
      name: 'membershipRules',
      props: true,
      component: () => import('./views/My/Member/MembershipRules'),
      meta: { title: '会员规则', requireAuth: false}
    },
    {
      path: '/my/member/platform/member',
      name: 'platformMember',
      props: true,
      component: () => import('./views/My/Member/platform/Member'),
      meta: { title: '平台会员管理', requireAuth: true, cn: '会员管理 - 平台会员'}
    },
    {
      path: '/my/member/platform/subordinate',
      name: 'platformSubordinate',
      props: true,
      component: () => import('./views/My/Member/platform/Subordinate'),
      meta: { title: '平台会一级用户', requireAuth: true, cn: '会员管理 - 平台会员 - 一级用户管理'}
    },
    {
      path: '/my/member/platform/oneUser',
      name: 'platformOneUser',
      props: true,
      component: () => import('./views/My/Member/platform/OneUser'),
      meta: { title: '云柑社区', requireAuth: true, cn: '会员管理 - 平台会员 - 一级用户详情'}
    },
    {
      path: '/my/member/platform/statistics',
      name: 'platformStatistics',
      props: true,
      component: () => import('./views/My/Member/platform/Statistics'),
      meta: { title: '平台用户统计',  requireAuth: true, cn: '会员管理 - 平台会员 - 用户统计'}
    },
    {
      path: '/my/member/platform/reward',
      name: 'platformReward',
      props: true,
      component: () => import('./views/My/Member/platform/Reward'),
      meta: { title: '奖金明细',  requireAuth: true, cn: '会员管理 - 平台会员 - 奖金明细'}
    },
    {
      path: '/my/member/platform/rewardCoin',
      name: 'platformRewardCoin',
      props: true,
      component: () => import('./views/My/Member/platform/RewardCoin'),
      meta: { title: '金币奖励明细',  requireAuth: true, cn: '会员管理 - 平台会员 - 金币奖励明细'}
    },

    {
      path: '/my/shoppingAwards',
      name: 'shoppingAwards',
      props: true,
      component: () => import('./views/My/ShoppingAwards/index'),
      meta: { title: '购物奖励', requireAuth: true, cn: '我的 - 购物奖励'}
    },
    {
      path: '/my/shoppingAwards/list',
      name: 'shoppingRewardRecord',
      props: true,
      component: () => import('./views/My/ShoppingAwards/list'),
      meta: { title: '金币奖励明细', requireAuth: true, cn: '我的 - 购物奖励-明细'}
    },

    {
      path: '/my/sgOrder',
      name: 'sgOrder',
      props: true,
      component: () => import('./views/My/sgOrder/index'),
      meta: { title: '云柑社区', requireAuth: true, cn: '商品订单-订单列表'}
    },
    {
      path: '/my/sgOrderDetail',
      name: 'sgOrderDetail',
      props: true,
      component: () => import('./views/My/sgOrder/sgOrderDetail'),
      meta: { title: '订单详情', requireAuth: true, cn: '商品订单-订单详情'}
    },
    {
      path: '/my/sgOrderTrack',
      name: 'sgOrderTrack',
      props: true,
      component: () => import('./views/My/sgOrder/sgOrderTrack'),
      meta: { title: '订单跟踪', requireAuth: true, cn: '商品订单-订单详情-订单物流'}
    },

    {
      path: '/my/knowledgeOrder',
      // redirect: '/my/knowledgeOrder/',
      component: () => import('./components/RouterView'),
      children: [
        {
          path: 'history',
          name: 'knowledgeOrderHistory',
          props: true,
          component: () => import('./views/My/KnowledgeOrder/History/index'),
          meta: { title: '订单记录', requireAuth: true, cn: '订单记录'}
        },{
          path: 'history/knowDetail',
          name: 'knowDetail',
          props: true,
          component: () => import('./views/My/KnowledgeOrder/History/KnowDetail'),
          meta: { title: '订单详情', requireAuth: true, cn: '订单详情'}
        },{
          path: 'history/shopMemberDetailDetail',
          name: 'shopMemberDetailDetail',
          props: true,
          component: () => import('./views/My/KnowledgeOrder/History/ShopMemberDetail'),
          meta: { title: '订单详情', requireAuth: true, cn: '订单详情'}
        },{
          path: 'myStudy',
          name: 'myStudy',
          props: true,
          component: () => import('./views/My/KnowledgeOrder/MyStudy'),
          meta: { title: '我的学习', requireAuth: true, cn: '我的学习'}
        },
      ]
    },


    // {
    //   path: '/my/order/assess',
    //   name: 'assess',
    //   component: () => import('./views/My/KnowledgeOrder/Assess'),
    //   meta: { title: '云柑社区', requireAuth: true, cn: '评价'}
    // },
    // {
    //   path: '/my/order/assessed',
    //   name: 'assessed',
    //   component: () => import('./views/My/KnowledgeOrder/Assessed'),
    //   meta: { title: '云柑社区', requireAuth: true, cn: '已评价'}
    // },


    {
      path: '/my/service',
      name: 'service',
      props: true,
      component: () => import('./views/My/Service'),
      meta: { title: '客服中心', requireAuth: true, cn: '客服中心'}
    },
    {
      path: '/my/setting',
      name: 'setting',
      props: true,
      component: () => import('./views/My/Setting'),
      meta: { title: '设置', requireAuth: true, cn: '设置'}
    },



    // ------------ 商城相关 -------------------------------------------------------------------------------------------------------//
    {
      path: '/mall/mallKnow',
      name: 'mallKnow',
      props: true,
      component: () => import('./views/Mall/indexComponents/know'),
      meta: { title: '微课', requireAuth: false, cn: '微课'}
    },
    {
      path: '/mall/shopList',
      name: 'mallShopList',
      props: true,
      component: () => import('./views/Mall/MallShopList'),
      meta: { title: '云店', requireAuth: false, cn: '微课的云店列表'}
    },
    {
      path: '/mall/search',
      name: 'mallSearch',
      props: true,
      component: () => import('./views/Mall/Search'),
      meta: { title: '搜索', keepAlive: true, requireAuth: true, cn: '商城-搜索'}
    },
    {
      path: '/mall/mallShop',
      name: 'mallShop',
      props: true,
      component: () => import('./views/Mall/MallShop'),
      meta: { title: '云柑社区', requireAuth: true, cn: '商城-店铺主页'}
    },
    {
      path: '/mall/mallShopDetail',
      name: 'mallShopDetail',
      props: true,
      component: () => import('./views/Mall/MallShopDetail'),
      meta: { title: '云柑社区', requireAuth: true, cn: '商城-店铺详情'}
    },
    {
      path: '/mall/mallShopMember',
      name: 'mallShopMember',
      props: true,
      component: () => import('./views/Mall/MallShopMember'),
      meta: { title: '会员礼包', requireAuth: true, cn: '商城-店铺会员'}
    },
    {
      path: '/mall/mallShopMemberBuy',
      name: 'mallShopMemberBuy',
      props: true,
      component: () => import('./views/Mall/MallShopMemberBuy'),
      meta: { title: '确定支付', requireAuth: true, cn: '商城-店铺会员-下单购买'}
    },

    {
      path: '/mall/mallShopGoodsMore',
      name: 'mallShopGoodsMore',
      props: true,
      component: () => import('./views/Mall/MallShopGoodsMore'),
      meta: { title: '更多商品',  requireAuth: true, cn: '商城-店铺详情-更多商品'}
    },
    {
      path: '/mall/goodsDetail',
      name: 'goodsDetail',
      props: true,
      component: () => import('./views/Mall/GoodsDetail'),
      // props: (route) => ({ goodsId: route.query.goodsId }),
      meta: { title: '云柑社区', requireAuth: true, cn: '商城-商品详情'},
    },
    {
      path: '/mall/detail',
      component: () => import('./views/Mall/mallbase'),
      name: 'curriculumBase',
      props: true,
      children:[
        {
          path: 'curriculumDetail',
          name: 'curriculumDetail',
          props: true,
          component: () => import('./views/Mall/GoodsDetail'),
          // props: (route) => ({ goodsId: route.query.goodsId }),
          meta: { title: '云柑社区', requireAuth: true, cn: '商城-专栏详情课程'}
        },
      ]
    },
    {
      path: '/mall/paymentResults',
      name: 'PaymentResults',
      props: true,
      component: () => import('./views/Mall/PaymentResults'),
      meta: { title: '支付结果', requireAuth: true, cn: '支付结果'}
    },
    {
      path: '/mall/orderPreview',
      name: 'orderPreview',
      props: true,
      component: () => import('./views/Mall/OrderPreview'),
      meta: { title: '确认下单', requireAuth: true, cn: '确认下单'}
    },
    {
      path: '/mall/categoryMore',
      name: 'categoryMore',
      props: true,
      component: () => import('./views/Mall/CategoryMore'),
      meta: { title: '云柑社区', requireAuth: true, cn: '商城-分类-更多'}
    },
    {
      path: '/mall/popularMore',
      name: 'popularMore',
      props: true,
      component: () => import('./views/Mall/PopularMore'),
      meta: { title: '更多商品', requireAuth: true, cn: '更多商品'}
    },
    {
      path: '/mall/goodsComplaintType',
      name: 'goodsComplaintType',
      props: true,
      component: () => import('./views/Mall/ComplaintType'),
      meta: { title: '投诉理由', requireAuth: true, cn: '商品投诉理由'}
    },
    {
      path: '/mall/goodsComplaint',
      name: 'goodsComplaint',
      props: true,
      component: () => import('./views/Mall/Complaint'),
      meta: { title: '投诉', requireAuth: true, cn: '商品投诉'}
    },
    // {
    //   path: '/mall/liveRoom',
    //   name: 'liveRoom',
    //   props: true,
    //   component: () => import('./views/Mall/LiveRoom'),
    //   meta: { title: '云柑社区', requireAuth: true, cn: '直播间----待删------'}
    // },
    //////--  1.5.0版本省购/京东  --///////////
    {
      path: '/mall/sgSearch',
      name: 'sgSearch',
      props: true,
      component: () => import('./views/Mall/sg/sgSearch'),
      meta: { title: '搜索', requireAuth: true, cn: '商城-搜索'}
    },
    {
      path: '/mall/classification',
      name: 'classification',
      props: true,
      component: () => import('./views/Mall/sg/classification'),
      meta: { title: '商品分类', requireAuth: true, cn: '商城-商品分类'}
    },
    {
      path: '/sg/sgGoodsList',
      name: 'sgGoodsList',
      props: true,
      component: () => import('./views/Mall/sg/sgGoodsList'),
      meta: { title: '云柑京购', keepAlive: false, requireAuth: true, cn: '云柑京购'}
    },
    {
      path: '/jd/jdGoodsDetail',
      name: 'jdGoodsDetail',
      props: true,
      component: () => import('./views/Mall/sg/jdGoodsDetail'),
      meta: { title: '云柑社区', requireAuth: true, cn: '京东商城-商品详情'}
    },
    {
      path: '/sg/sgGoodsEvaluationList',
      name: 'sgGoodsEvaluationList',
      props: true,
      component: () => import('./views/Mall/sg/sgGoodsEvaluationList'),
      meta: { title: '更多评论', requireAuth: true, cn: '商品详情-商品评论'}
    },
    {
      path: '/sg/sgPopularMore',
      name: 'sgPopularMore',
      props: true,
      component: () => import('./views/Mall/sg/sgPopularMore'),
      meta: { title: '更多商品', requireAuth: true, cn: '更多商品'}
    },
    {
      path: '/sg/sgShopList',
      name: 'sgShopList',
      props: true,
      component: () => import('./views/Mall/sg/sgShopList'),
      meta: { title: '店铺', requireAuth: true, cn: '省购的店铺列表'}
    },
    {
      path: '/sg/sgShopIndex',
      name: 'sgShopIndex',
      props: true,
      component: () => import('./views/Mall/sg/sgShopIndex'),
      meta: { title: '云柑社区', requireAuth: true, cn: '省购店铺主页'}
    },
    {
      path: '/sg/sgShopGoodsMore',
      name: 'sgShopGoodsMore',
      props: true,
      component: () => import('./views/Mall/sg/sgShopGoodsMore'),
      meta: { title: '更多商品', requireAuth: true, cn: '省购店铺主页--更多商品'}
    },
    {
      path: '/sg/sgConfirmOrder',
      name: 'sgConfirmOrder',
      props: true,
      component: () => import('./views/My/sgOrder/sgConfirmOrder'),
      meta: { title: '确认订单', requireAuth: true, cn: '下单-确认订单'}
    },
    {
      path: '/sg/sgConfirmOrderPay',
      name: 'sgConfirmOrderPay',
      props: true,
      component: () => import('./views/My/sgOrder/sgConfirmOrderPay'),
      meta: { title: '订单支付', requireAuth: true, cn: '下单-订单支付'}
    },
    {
      path: '/sg/sgOrderPayOK',
      name: 'sgOrderPayOK',
      props: true,
      component: () => import('./views/My/sgOrder/sgOrderPayOK'),
      meta: { title: '购买成功', requireAuth: true, cn: '下单-订单支付--购买成功'}
    },
    {
      path: '/sg/sgOrderEvaluated',
      name: 'sgOrderEvaluated',
      props: true,
      component: () => import('./views/My/sgOrder/sgOrderEvaluated'),
      meta: { title: '评价', requireAuth: true, cn: '订单--评价'}
    },
    {
      path: '/sg/newActivity',
      name: 'newActivity',
      props: true,
      component: () => import('./views/Mall/sg/newActivity'),
      meta: { title: '活动', requireAuth: true, cn: ''}
    },
    {
      path: '/sg/sgCoinGoods',
      name: 'sgCoinGoods',
      props: true,
      component: () => import('./views/Mall/sg/sgCoinGoods'),
      meta: { title: '金币抵扣专区', requireAuth: true, cn: ''}
    },









    //---------------------------  云柑号 ------------------------------//
    {
      path: '/article/articleDetail',
      name: 'articleDetail',
      props: true,
      component: () => import('./views/Article/articleDetail'),
      meta: { title: '云柑社区', requireAuth: true, cn: '云柑号详情页'}
    },
    // --------------  2020.06.24 5g云店视频分享------------
    {
      path: '/5gLive',
      name: '5gLive',
      props: true,
      component: () => import('./views/5gVideo/5gLive'),
      meta: { title: '云柑5G云店', requireAuth: true, cn: ''}
    },
    {
      path: '/shopVideoList',
      name: 'shopVideoList',
      props: true,
      component: () => import('./views/5gVideo/shopVideoList'),
      meta: { title: '云柑5G云店-视频列表', requireAuth: true, cn: '店铺视频列表'}
    },
    {
      path: '/shopVideoDetail',
      name: 'shopVideoDetail',
      props: true,
      component: () => import('./views/5gVideo/shopVideoDetail'),
      meta: { title: '云柑5G云店-视频详情', requireAuth: true, cn: '店铺视频详情'}
    },
    {
      path: '/shopLiveList',
      name: 'shopLiveList',
      props: true,
      component: () => import('./views/5gVideo/shopLiveList'),
      meta: { title: '云柑5G云店-直播列表', requireAuth: true, cn: '店铺直播列表'}
    },
    {
      path: '/shopLiveDetail',
      name: 'shopLiveDetail',
      props: true,
      component: () => import('./views/5gVideo/shopLiveDetail'),
      meta: { title: '云柑5G云店-直播详情', requireAuth: true, cn: '店铺直播详情'}
    },
    {
      path: '/shopLiveReplayList',
      name: 'shopLiveReplayList',
      props: true,
      component: () => import('./views/5gVideo/shopLiveReplayList'),
      meta: { title: '云柑5G云店-直播回放列表', requireAuth: true, cn: '店铺直播回放列表'}
    },
    {
      path: '/shopLiveReplayDetail',
      name: 'shopLiveReplayDetail',
      props: true,
      component: () => import('./views/5gVideo/shopLiveReplayDetail'),
      meta: { title: '云柑5G云店-直播回放', requireAuth: true, cn: '店铺直播回放详情'}
    },
    {
      path: '/shopArticle',
      name: 'shopArticle',
      props: true,
      component: () => import('./views/5gVideo/shopArticle'),
      meta: { title: '云柑5G云店-店铺动态列表', requireAuth: true, cn: '店铺动态列表'}
    },

    //-----------------------------  注册相关   -------------------------------//
    {
      path: '/h5/register',
      name: 'h5Register',
      props: true,
      component: () => import('./views/Register/index'),
      meta: { title: '云柑社区', requireAuth: false, cn: '注册页面'}
    },
    {
      path: '/h5/register/phone',
      name: 'h5RegisterPhone',
      props: true,
      component: () => import('./views/Register/phone'),
      meta: { title: '云柑社区', requireAuth: false, cn: '注册页面'}
    },
    {
      path: '/h5/register/weixin',
      props: true,
      name: 'h5RegisterWeiXin',
      component: () => import('./views/Register/weixin'),
      meta: { title: '云柑社区', requireAuth: false, cn: '微信授权页面'}
    },
    {
      path: '/h5/register/getApps',
      name: 'h5RegisterDownload',
      props: true,
      component: () => import('./views/Register/download'),
      meta: { title: '云柑社区', requireAuth: false, cn: '下载APP'}
    },
    {
      path: '/h5/register/getAiApps',
      name: 'h5RegisterDownloadAi',
      props: true,
      component: () => import('./views/Register/downloadAi'),
      meta: { title: 'AI', requireAuth: false, cn: '下载APP'}
    },



    // {
    // path: '/about',
    // name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }

    {
      path: '/ygAgent',
      name: 'ygAgent',
      props: true,
      component: () => import('./views/info202311/index'),
      meta: { title: '云柑支付推广达人报名表（省市区县服务商限时赠送）', requireAuth: false, cn: '云柑支付推广达人报名表（省市区县服务商限时赠送）'}
    },

    {
      path: '/noviceGuide',
      name: 'noviceGuide',
      props: true,
      component: () => import('./views/noviceGuide/index'),
      meta: { title: '新手指引', requireAuth: false, cn: '新手指引'}
    },
    {
      path: '/noviceGuide/question',
      name: 'question',
      props: true,
      component: () => import('./views/noviceGuide/question/index'),
      meta: { title: '新手指引', requireAuth: false, cn: '新手指引'}
    },


    {
      path: '/money-strategy',
      name: 'moneyStrategy',
      props: true,
      component: () => import('./views/Mall/moneyStrategy'),
      meta: { title: '赚钱攻略', requireAuth: false, cn: '赚钱攻略'}
    },


    {
      path: '/weixin/wxPay',
      name: 'wxPay',
      props: true,
      component: () => import('./views/weixin/wxPay'),
      meta: { title: '微信支付', requireAuth: true, cn: '微信支付'}
    },



    // 其他链接处理
    {
      path: '/a/:code',
      name: 'openApp',
      props: true,
      component: () => import('./views/appOpen/a'),
      meta: { title: '云柑社区', requireAuth: false, cn: 'APP扫码、短信短连接跳转，拉起APP、小程序'}
    },
    // app展示页
    {
      path: '/org/banner/page01',
      name: 'introduceIndex',
      props: true,
      component: () => import('./views/appOpen/orgBanner/page01'),
      meta: { title: '云柑社区', requireAuth: false, cn: 'app展示页面-组织直播banner详情'}
    },
    {
      path: '/org/banner/page02',
      name: 'introduceOrg',
      props: true,
      component: () => import('./views/appOpen/orgBanner/page02'),
      meta: { title: '云柑社区', requireAuth: false, cn: 'app展示页面-组织直播banner详情'}
    },
    {
      path: '/org/banner/page03',
      name: 'introduceShop',
      props: true,
      component: () => import('./views/appOpen/orgBanner/page03'),
      meta: { title: '云柑社区', requireAuth: false, cn: 'app展示页面-组织直播banner详情'}
    },
    // app展示页,社区公约：
    {
      path: '/community/convention',
      name: 'convention',
      props: true,
      component: () => import('./views/community/convention'),
      meta: { title: '社区公约', requireAuth: false, cn: 'app首页-社区公约'}
    },
    // app展示页，店铺相关
    {
      path: '/shop/rewardSettingRule',
      name: 'shopRewardSettingRule',
      props: true,
      component: () => import('./views/appOpen/shop/rewardSettingRule'),
      meta: { title: '', requireAuth: false, cn: 'app-店铺-奖励设置'}
    },
    {
      path: '/shop/memberSettingRule',
      name: 'shopMemberSettingRule',
      props: true,
      component: () => import('./views/appOpen/shop/memberSettingRule'),
      meta: { title: '', requireAuth: false, cn: 'app-店铺-会员设置'}
    },
    {
      path: '/shop/commodityTypeRule',
      name: 'shopCommodityTypeRule',
      props: true,
      component: () => import('./views/appOpen/shop/commodityTypeRule'),
      meta: { title: '', requireAuth: false, cn: 'app-店铺-商品类型'}
    },
    {
      path: '/shop/labelSettingRule',
      name: 'shopLabelSettingRule',
      props: true,
      component: () => import('./views/appOpen/shop/labelSettingRule'),
      meta: { title: '', requireAuth: false, cn: 'app-店铺-标签设置'}
    },
    {
      path: '/shop/productSpecificationsRule',
      name: 'shopProductSpecificationsRule',
      props: true,
      component: () => import('./views/appOpen/shop/productSpecificationsRule'),
      meta: { title: '', requireAuth: false, cn: 'app-店铺-商品规格'}
    },










    {
      path: "*",
      redirect: "/404"
    }
  ]
})



export default router
